import React, {PureComponent} from "react";
import {connect} from "react-redux";
import {
    SHOW_UNDO_SNACKBAR, undoAndPreviousTask
} from "./Redux/Actions";
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button'
import Snackbar from "housecall-ui/dist/DesignSystem/Feedback/Snackbar/Snackbar"
import ui from "redux-ui";

@connect(
    state => ({}),
    dispatch => ({
        undoTask: () => {
            dispatch(undoAndPreviousTask())
        },
    })
)
@ui({
    state: {
        showSnackbar: false,
        message: ''
    },
    reducer: (state, action) => {
        switch (action.type) {
            case SHOW_UNDO_SNACKBAR:
                return state.set('showSnackbar', true)
                    .set('message', action.message )
        }
        return state;
    }
})
export default class UndoSnackbar extends PureComponent {
    render() {
        const {ui} = this.props;
        return <Snackbar
            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
            open={ui.showSnackbar}
            autoHideDuration={2500}
            onClose={() => {
                this.props.updateUI('showSnackbar', false)
            }}
            snackbarcontentprops={{
                'aria-describedby': 'message-id',
            }}
            message={<span id="message-id">{ui.message}</span>}
            action={[
                <Button key="undo" color="primary" size='small' onClick={() => {
                    this.props.updateUI('showSnackbar', false)
                    this.props.undoTask()
                }}>
                    UNDO
                </Button>
            ]}
        />
    }
}
